import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Segment, Form, Button, Container, Grid, Header, Icon, Label } from 'semantic-ui-react'

import API from '../../../services/Api'

var fileDownload = require('react-file-download');

class ConnectedExportUser extends Component {
    constructor(props){
        super(props);

        // Handle Submit
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event){
        event.preventDefault();
        // var xdr = new XMLHttpRequest(); 
        // xdr.open("POST", this.props.app.dns+'v1/email-export', true);
        // xdr.setRequestHeader("Authorization", "Bearer "+this.props.app.token);
        // xdr.send();

        // xdr.onload = function() {
        //     var response = xdr.response;
        //     var today = new Date(),
        //     date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        //     fileDownload(response, 'ExportEmail'+date+'.csv');
        
        // }

        API.getClients().then(res => {
            var response = res.data.users
            var today = new Date();
            let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            let lines = response.map(x => `${x.id};${x.name};${x.email}`);
            let data = lines.join('\n')
            fileDownload(data, 'ExportEmail'+date+'.csv');
        })

    }

    render() {
        return (
            <div className="ui container">
                <div className="ui center aligned container">
                <br/>
                <h1 className="ui header">User Area</h1>
                <h2 className="ui header">Export</h2>
                <br/>
                </div>
                <div className="ui center aligned container">
                    <div className="ui column"></div>
                    <div className="ui column">
                        <form onSubmit={this.handleSubmit}>
                            <button className="ui massive button" type="submit" role="button">
                            <i className="download icon"></i>
                            Export
                            </button>
                        </form>
                    </div>    

                </div>
            </div>

        );
  }
}

const ExportUser = (ConnectedExportUser);

export default ExportUser;



// WEBPACK FOOTER //
// ./src/components/Protected/User/ExportEmail.jsx